import { render, staticRenderFns } from "./orderDZ.vue?vue&type=template&id=16840616&scoped=true"
import script from "./orderDZ.vue?vue&type=script&lang=js"
export * from "./orderDZ.vue?vue&type=script&lang=js"
import style0 from "./orderDZ.vue?vue&type=style&index=0&id=16840616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16840616",
  null
  
)

export default component.exports